import {http} from "../http";
import {Company} from "../company";

export interface Deposit{
    CUSTOMER_NO : number,
    BRANCH_NO : string,
    BRANCH_NAME : string,
    ACCOUNT_NO : string,
    IBAN : string,
    CCY_NAME : string,
    BALANCE : string,
    BALANCE_LC : string,
    INTEREST_ACC : string,
    INTEREST_RATIO : string,
    INT_BALANCE : string,
    PRODUCT_CODE : number,
    PRODUCT_NAME : string,
    OPENDATE : string,
    MATURITY_DATE : string,
    STATUS : string,
    BLOCKSTATUS : string,
    BLOCKSAMOUNT : string,
    INITIALAMOUNT : string,
    PAYMENTPERIOD : string,
    periodYear : string,
    periodMonth : string,
    periodDay : string,
    taxRate : string,
    taxAmount : string,
    taxPymAmount : string,
    nickName: string
}

export const getDeposits = async (company : Company): Promise<Deposit[]> => {
    const { data } = await http.get<Deposit[]>(`customers/${company.customerNo}/timedeposits`);
    return data;
};